import { PushPin } from "@mui/icons-material";
import { styled } from "@mui/material";
import { memo } from "react";

const PinFilledIcon = ({ ...otherProps }) => {
  return <CustomPinFilled {...otherProps} />;
};

export default memo(PinFilledIcon);

const CustomPinFilled = styled(PushPin)(props => ({
  fontSize: 14,
  transform: "rotate(45deg)",
  color: props.theme.palette.grey[500],
}));
